module.exports = __webpack_public_path__ + "static/media/icon-male-purple.fc800bc1.svg";